import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from 'features/creativeFunctionality/redux';

const useSocialMedia = () => {
  const dispatch = useDispatch();
  const { socialMedia } = useSelector(state => state.creativeFunctionality);
  const [state, setState] = useState({
    instagram: '',
    telegram: '',
    facebook: '',
  });
  const handleSocialLinkChange = useCallback(
    ({ social, link }) => {
      setState(prev => ({ ...prev, [social]: link }));
    },
    [dispatch],
  );

  const handleGetSocialMediaRequest = () => {
    dispatch(actions.getSocialMedia());
  };

  useEffect(() => {
    handleGetSocialMediaRequest();
  }, []);

  useEffect(() => {
    setState(socialMedia);
  }, [socialMedia]);

  const handleUpdateLink = useCallback(
    data => {
      dispatch(actions.setSocialRequest(data));
    },
    [dispatch],
  );

  const socialLinksCount = useMemo(() => Object.values(socialMedia).filter(Boolean).length, [socialMedia]);

  return {
    values: {
      state,
      socialMedia,
      socialLinksCount,
    },
    handlers: {
      handleSocialLinkChange,
      handleGetSocialMediaRequest,
      handleUpdateLink,
    },
  };
};

export default useSocialMedia;
